module.exports = __webpack_public_path__ + "static/bg_mobo-714d77cd67ba27bee5935f2017b468c8.jpg";